import * as React from 'react'
import { connect } from 'react-redux'

import hardLogin from '../../project-utils/hard-login'
import {
  ApplicationState,
  loginMentoringRequest,
  selectAuthState,
} from '../../redux'
import { AccountType } from '../../api'
import { LoginForm } from '../forms'
import { Button } from "../atoms"
import { api } from "../../config";
import { indraEnabled } from "../../theme"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import styled from 'styled-components'
import IconButton     from '@material-ui/core/IconButton'
import { Grid } from '@material-ui/core'

const mstp = (state: ApplicationState) => ({
  loginCommunication: loginMentoringRequest.communicationSelector(state),
  authentication: selectAuthState(state)
})

const ExpandMore = styled(ExpandMoreIcon)`
  transform: rotate(${({ isexpanded: isExpanded }: { isexpanded: boolean }) => isExpanded ? '180' : '0' }deg);
  transition: ${
  ({ theme: { transitions: { create, duration } } }) =>
    create('transform', { duration: duration.shortest })
  }
`

const ExpandMoreIconButton = styled(IconButton)`
  margin-left: auto;
`

const actions = {
  login: loginMentoringRequest.actionCreator,
}



type Props =
  typeof actions
  & ReturnType<typeof mstp> 

type State = {
  error: string | null,
  expanded: boolean
}


class Login extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      error: null,
      expanded: false
    }
    this.onExpandClick = this.onExpandClick.bind(this);
  }

  private onExpandClick() {
    this.setState({expanded : !this.state.expanded })
  }
  
  public componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)

    const token = urlParams.get('token')!
    const type = urlParams.get('type')!
    const error = urlParams.get('error')!
    console.log('error', error);

    if (error == '1') {
      this.setState({ error: 'El usuario no está dado de alta en la plataforma' })
    }
    let t: AccountType
    switch (type) {
      case 'mentor':
        t = AccountType.Mentor
        break
      case 'mentee':
        t = AccountType.Mentee
        break
      case 'company':
        t = AccountType.CompanyMentoring
        break
      case 'admin':
        t = AccountType.BlcMentoring
        break
      default:
        t = AccountType.Mentee
        break
    }
    if (token && type) {
      hardLogin({ token, type: t })
    }
  }

  public componentDidUpdate({ authentication: lastAuthentication }: Props) {
    const { authentication: { type, token } } = this.props

    if (
      !lastAuthentication.token
      && token
      && type
    ) {
      hardLogin({ type, token })
    }
  }
  M
  public render() {
    const { login, loginCommunication } = this.props // login

    return (
      <>
        {this.state.expanded &&
          <>
        <LoginForm
          onSubmit={login}
          {...loginCommunication}
        />
        {this.state.error && <div style={{
          color: 'red',
          textAlign: 'center',
          padding: 5,
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
          }}>{this.state.error}</div>}
          </>
       }
        {indraEnabled && <div>
          <Grid item>
          <Button id='indra-login' style={{
            width: '100%',
            height: 50,
            borderRadius: '0px 0px 3px 3px',
            border: 'none',
            color: 'white'
          }} onClick={() => {
            window.location.href = api + '/login'
          }}>
            Indra login
          </Button>
           <ExpandMoreIconButton onClick={this.onExpandClick}>
                    <ExpandMore isexpanded={this.state.expanded} />
            </ExpandMoreIconButton>
            </Grid>
        </div>}
      </>
    )
  }
}



export default connect(mstp, actions)(Login)



// WEBPACK FOOTER //
// ./src/components/organisms/Login.tsx